import { render } from "./RecuperoTicketDoppi.vue?vue&type=template&id=2194e8cb&scoped=true"
import script from "./RecuperoTicketDoppi.vue?vue&type=script&lang=js"
export * from "./RecuperoTicketDoppi.vue?vue&type=script&lang=js"

import "./RecuperoTicketDoppi.vue?vue&type=style&index=0&id=2194e8cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2194e8cb"]])

export default __exports__